import { useNavigate } from 'react-router-dom';

const JoinSection = () => {
  const navigate = useNavigate();

  const ways = [
    {
      title: 'Become a Mentee',
      description: 'Rising Latina talent ready to level up? Connect with leaders who get it.',
      cta: 'Apply Now',
      link: '/join',
      color: 'primary',
      icon: 'ri-user-star-line',
    },
    {
      title: 'Become a Mentor',
      description: 'Latina leader with wisdom to share? Give back and shape the next generation.',
      cta: 'Join as Mentor',
      link: '/join',
      color: 'secondary',
      icon: 'ri-hand-heart-line',
    },
    {
      title: 'Partner With Us',
      description: 'Organizations committed to Latina leadership? Let\'s build together.',
      cta: 'Explore Partnership',
      link: '/join',
      color: 'electric',
      icon: 'ri-team-line',
    },
    {
      title: 'Support the Movement',
      description: 'Every dollar fuels mentorship, programs, and economic mobility for Latinas.',
      cta: 'Donate Now',
      link: '/donate',
      color: 'primary',
      icon: 'ri-heart-3-line',
    },
  ];

  // Color mapping for Tailwind classes
  const colorClasses = {
    primary: {
      bg: 'bg-primary',
      bgHover: 'hover:bg-primary/90',
      bgLight: 'bg-primary/20',
      text: 'text-primary',
    },
    secondary: {
      bg: 'bg-secondary',
      bgHover: 'hover:bg-secondary/90',
      bgLight: 'bg-secondary/20',
      text: 'text-secondary',
    },
    electric: {
      bg: 'bg-electric',
      bgHover: 'hover:bg-electric/90',
      bgLight: 'bg-electric/20',
      text: 'text-electric',
    },
  };

  const handleClick = (link: string) => {
    try {
      if (link.startsWith('/')) {
        navigate(link);
      } else if (link.startsWith('#')) {
        const element = document.getElementById(link.substring(1));
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        } else {
          console.warn(`Element with id "${link.substring(1)}" not found`);
        }
      } else {
        window.open(link, '_blank', 'noopener,noreferrer');
      }
    } catch (error) {
      console.error('Error handling click:', error);
    }
  };

  return (
    <section id="join" className="py-32 bg-charcoal relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-primary/5 via-transparent to-secondary/5"></div>
      
      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        <div className="text-center mb-20">
          <h2 className="font-poppins font-black text-5xl sm:text-6xl md:text-7xl text-white mb-6 leading-tight">
            Get Involved
          </h2>
          <div className="w-24 h-2 bg-primary mx-auto mb-8"></div>
          <p className="font-inter text-xl text-white/80 max-w-3xl mx-auto font-medium">
            This movement needs you. Choose your path.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {ways.map((way, index) => {
            const colors = colorClasses[way.color as keyof typeof colorClasses];
            if (!colors) {
              console.error(`Invalid color "${way.color}" for item at index ${index}`);
              return null;
            }
            
            return (
              <div
                key={index}
                className="bg-white/5 backdrop-blur-sm p-10 rounded-3xl border border-white/10 hover:border-primary transition-all duration-300 group"
              >
                <div className={`w-16 h-16 flex items-center justify-center ${colors.bgLight} rounded-xl mb-6 group-hover:scale-110 transition-transform`}>
                  <i className={`${way.icon} text-3xl ${colors.text}`}></i>
                </div>
                <h3 className="font-poppins font-bold text-3xl text-white mb-4">{way.title}</h3>
                <p className="font-inter text-lg text-white/70 mb-8 leading-relaxed">{way.description}</p>
                <button
                  onClick={() => handleClick(way.link)}
                  className={`${colors.bg} ${colors.bgHover} text-white font-inter font-bold px-8 py-4 rounded-lg transition-all duration-300 transform hover:scale-105 cursor-pointer whitespace-nowrap`}
                >
                  {way.cta}
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default JoinSection;
